import { render, staticRenderFns } from "./water-status.vue?vue&type=template&id=2ce51405&scoped=true&"
import script from "./water-status.vue?vue&type=script&lang=js&"
export * from "./water-status.vue?vue&type=script&lang=js&"
import style0 from "./water-status.vue?vue&type=style&index=0&id=2ce51405&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce51405",
  null
  
)

export default component.exports